import { Lock } from "lucide-react";

export default function ComingSoon({ title, description, icon: Icon = Lock }) {
  const testId = `coming-soon-${title.toLowerCase().replace(/\s+/g, "-")}`;
  return (
    <div className="flex items-center justify-center min-h-[65vh] px-4" data-testid={testId}>
      <div className="card-lux p-10 sm:p-12 text-center max-w-md w-full relative overflow-hidden">
        <div className="absolute -top-16 -right-16 h-40 w-40 rounded-full bg-[#D4AF37]/10 blur-3xl" />
        <div className="mx-auto h-14 w-14 rounded-xl bg-[#D4AF37]/10 border border-[#D4AF37]/30 flex items-center justify-center mb-6">
          <Icon className="h-6 w-6 text-[#D4AF37]" />
        </div>
        <span className="inline-block text-[10px] font-mono tracking-[0.25em] uppercase text-[#D4AF37] border border-[#D4AF37]/40 rounded-full px-3 py-1 mb-4" data-testid={`${testId}-badge`}>
          Coming Soon
        </span>
        <h2 className="font-heading text-2xl font-bold text-white mb-3">{title}</h2>
        <p className="text-sm text-[#94A3B8] leading-relaxed">{description}</p>
      </div>
    </div>
  );
}
